export default __webpack_public_path__ + "static/media/Tank_Device_Template.4ae51c86.xlsx";